import __request__ from "routing/request";
export function multipleMetrics(nodeId, Requestedmetrics, requestOptions) {
  return __request__("POST", `/cluster/${nodeId}/metrics/multiple`, Requestedmetrics, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function metricNames(nodeId, requestOptions) {
  return __request__("GET", `/cluster/${nodeId}/metrics/names`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function byNamespace(nodeId, namespace, requestOptions) {
  return __request__("GET", `/cluster/${nodeId}/metrics/namespace/${namespace}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
